import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from 'libs/portal/src/layout/layout.component';
import { DeviceDetailsComponent } from 'libs/portal/src/modules/tools/device-details/device-details.component';
import { AuthGuardService } from 'libs/portal/src/services/auth-guard/auth-guard.service';
import { KeepAliveComponent } from './keep-alive/keep-alive.component';

const routes: Routes = [
  // {
  //   path: 'CDR',
  //   component: LayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       pathMatch: 'full',
  //       component: CdrComponent,
  //     },
  //     // {
  //     //   path: '/:id',
  //     //   // pathMatch: 'full',
  //     //   component: DeviceDetailsComponent,
  //     // }
  //   ]
  // },
  {
    path: '',
    component: LayoutComponent,
    data: { breadcrumb: 'Devices' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: KeepAliveComponent,
      },
    ],
  },
  {
    path: 'Details',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    data: { breadcrumb: 'Details' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: DeviceDetailsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DevicesRoutingModule {}
